import { fetcher } from "utils";

export const get__members__badges__order_product_contacts = () => fetcher.get("/members/badges/order_product_contacts");
